import React, { Fragment, useState } from "react";
import {
	Box,
	Chip,
	Divider,
	IconButton,
	Menu,
	MenuItem,
	Tooltip,
	Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";

const AddressCard = ({ userAddress, handleDelete, isFav }) => {
	const [edit, setEdit] = useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const navigate = useNavigate();
	const open = Boolean(anchorEl);

	const handleClick = (evt) => {
		setAnchorEl(evt.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleEdit = (id) => {
		navigate(`/user-account/address-shipping/edit-addres?addressId=${id}`);
	};

	const toggleEdit = () => {
		setEdit((currentValue) => !currentValue);
	};

	return !edit ? (
		<Fragment>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					width: "100%",
					padding: "0.5rem",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						pt: 1,
					}}
				>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<LocationOnOutlinedIcon
							style={{ color: "#000000" }}
							sx={{ fontSize: 25 }}
						/>
						<Box>
							<Typography className="payment_title_typography">
								{`${userAddress.clientAddress}, Piso: ${
									userAddress.clientFloor || " - "
								} / Dpto: ${userAddress.clientDoor || " - "}`}
							</Typography>
							<Typography className="payment_title_typography">
								{`CP: ${userAddress.clientZipCode}. ${userAddress.clientCity}, ${userAddress.clientStateName}`}
							</Typography>
						</Box>
					</Box>
					<Box
						sx={{
							display: "flex",
							alignItems: "flex-start",
							height: "100%",
							ml: 2,
						}}
					>
						<Chip
							label={userAddress.clientAddressDescrp || "Principal"}
							variant="outlined"
							size="small"
							sx={{ marginRight: "0.5rem", textTransform: "capitalize" }}
						/>
						{isFav && (
							<Chip label="Predeterminada" variant="outlined" size="small" />
						)}
					</Box>
				</Box>

				<Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
					<MoreVertIcon onClick={handleClick} id="addressButton" />

					{userAddress.clientAddressDescrp !== undefined ? (
						<Menu
							id="basic-menu"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							MenuListProps={{
								"aria-labelledby": "basic-button",
							}}
						>
							<MenuItem onClick={() => handleEdit(userAddress.addressId)}>
								Editar
							</MenuItem>
							<MenuItem
								onClick={() => {
									handleDelete(userAddress.addressId);
									handleClose();
								}}
							>
								Eliminar
							</MenuItem>
						</Menu>
					) : (
						<Menu
							id="basic-menu"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							MenuListProps={{
								"aria-labelledby": "basic-button",
							}}
						>
							<MenuItem onClick={handleEdit}>Editar</MenuItem>
						</Menu>
					)}
				</Box>
			</Box>
			<Box sx={{ width: "100%" }}>
				<Divider />
			</Box>
		</Fragment>
	) : (
		<Box>
			<Tooltip title="Cerrar">
				<IconButton
					size="large"
					aria-label="Cerrar edición de dirección"
					aria-controls="cierre-edición"
					aria-haspopup="false"
					color="inherit"
					onClick={toggleEdit}
				>
					<CloseIcon color="secondary" sx={{ fontSize: "1.5rem" }} />
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default AddressCard;
